var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ("timer timer__" + (_vm.size) + " timer__" + (_vm.color))
  }, [_c('div', {
    staticClass: "timer__count"
  }, [_c('span', [_vm._v(_vm._s(_vm.formattedDays.count))]), _vm._v(" "), _c('span', {
    staticClass: "timer__text"
  }, [_vm._v(_vm._s(_vm.formattedDays.text))])]), _vm._v(" "), _c('span', {
    staticClass: "timer__colon"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "timer__count"
  }, [_c('span', [_vm._v(_vm._s(_vm.formattedHours.count))]), _vm._v(" "), _c('span', {
    staticClass: "timer__text"
  }, [_vm._v(_vm._s(_vm.formattedHours.text))])]), _vm._v(" "), _c('span', {
    staticClass: "timer__colon"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "timer__count"
  }, [_c('span', [_vm._v(_vm._s(_vm.formattedMinutes.count))]), _vm._v(" "), _c('span', {
    staticClass: "timer__text"
  }, [_vm._v(_vm._s(_vm.formattedMinutes.text))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }